export default {
	init() {
		// JavaScript to be fired on all pages

		// Navigation Toggle
		const navToggle = document.getElementById('nav-toggle');
		const navPrimary = document.getElementById('nav-primary');

		if (navToggle && navPrimary) {
			navToggle.addEventListener('click', (e) => {
				e.preventDefault();
				navToggle.classList.toggle('is-active');
				navPrimary.classList.toggle('is-active');
			});
		}
	},
	finalize() {
		// JavaScript to be fired on all pages, after init JS is fired
	},
};
